import react from "react";

const CommentModal = ({ closeCommentModal,selectedAddOnForComment,saveComment,addOnComments }) => {


  return (
      <div className="fixed inset-0 bg-black bg-opacity-20 z-50 flex items-center justify-center p-4 singup-modal" onClick={closeCommentModal}>
          <div className="bg-white rounded-lg max-w-md w-full p-6" onClick={e => e.stopPropagation()} >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">
                Add Comment
              </h3>
              <button
                onClick={closeCommentModal}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg
                  className="h-6 w-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <div className="mb-4">
              <h4 className="font-medium text-gray-900 mb-2">
                {selectedAddOnForComment.name}
              </h4>
              <p className="text-sm text-gray-600">
                {selectedAddOnForComment.category}
              </p>
            </div>
            <div className="mb-6">
              <label
                htmlFor="comment"
                className="block text-sm font-medium text-gray-700 mb-2"
              >
                Your Comment/Request
              </label>
              <textarea
                id="comment"
                rows={4}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Add any special requests, preferences, or notes for this service..."
                defaultValue={addOnComments[selectedAddOnForComment.id] || ""}
              />
            </div>
            <div className="flex space-x-3">
              <button
                onClick={closeCommentModal}
                className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  const comment = document.getElementById("comment").value;
                  saveComment(selectedAddOnForComment.id, comment);
                }}
                className="flex-1 px-4 py-2 avablity-btn text-white rounded-md  transition-colors"
              >
                Save Comment
              </button>
            </div>
          </div>
        </div>
  );
}

export default CommentModal;